// Parse a clipboard payload copied from Excel / Google Sheets into a flat list
// of non-negative integer quantities, preserving cell order (including blanks,
// which become 0 so alignment is kept).
//
// Excel/Sheets put TAB between cells in a row and NEWLINE between rows. A
// horizontal copy is a single tab-separated line; a vertical copy is one value
// per line. A single-cell copy still carries a trailing newline. We support all
// three so a "paste a row of numbers" gesture fills cells left-to-right.
export function parsePastedRow(text: string): number[] {
  const trimmed = text.replace(/\r/g, "").replace(/\n+$/, "");
  if (trimmed === "") return [];

  const lines = trimmed.split("\n");
  // Multi-line => vertical column copy (take the first cell of each line).
  // Single line => horizontal row copy (split into its tab-separated cells).
  const cells = lines.length > 1 ? lines.map((l) => l.split("\t")[0]) : lines[0].split("\t");

  return cells.map((c) => {
    // Keep digits and the decimal point; drop thousands separators, currency
    // symbols, and spaces. Assumes en-US formatting (comma = thousands, dot =
    // decimal) to match how the grid renders numbers. Decimals are rounded to
    // the nearest integer since quantities are whole units.
    const cleaned = c.replace(/[^\d.]/g, "");
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? Math.round(n) : 0;
  });
}
